import axios from 'axios'

const api = axios.create({
  baseURL: '/api/v2'
})

export default {
  getEvent: (nid) =>
    api({
      'method': 'GET',
      'url': '/event/' + nid,
    }),
  getAllDrupalEvents: () =>
    api({
      'method': 'GET',
      'url': '/all-drupal-event-data'
    }),
  getAllEventDates: () =>
    api({
      'method': 'GET',
      'url': '/all-event-dates'
    }),
  getFilteredContent: (vid) =>
    api({
      'method': 'GET',
      'url': '/filtered-content/' + vid,
    })
}
